<template>
  <nav
    class="navigation"
    :class="{
      'mobile': isMobile,
      'dark-theme': isLoginPage ||
        $route.path.includes('change_password') ||
        $route.path.includes('visit_cancellation') ||
        $route.path.includes('user_activation'),
      'hide': hideNav,
    }"
  >
    <div
      class="trademark-wrapper"
      @click="$router.push({ path: '/' })"
    >
      <svg svg-inline="" class="trademark" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" width="284" height="99" viewBox="0 0 284 99"><switch><g><path fill="none" d="M0 0h284v99H0z"/><path d="M234.693.461c-11.714 0-22.464 4.113-30.897 10.966C195.361 4.574 184.611.461 172.899.461c-11.714 0-22.464 4.113-30.898 10.965C133.567 4.573 122.817.461 111.103.461 99.39.461 88.64 4.574 80.206 11.426 71.771 4.574 61.021.461 49.307.461 22.223.461.268 22.416.268 49.5s21.955 49.039 49.039 49.039c11.714 0 22.464-4.113 30.898-10.966 8.434 6.853 19.184 10.966 30.897 10.966 11.714 0 22.464-4.113 30.898-10.966 8.435 6.853 19.185 10.966 30.898 10.966 11.713 0 22.463-4.113 30.897-10.966 8.434 6.853 19.184 10.966 30.897 10.966 27.084 0 49.039-21.955 49.039-49.039S261.777.461 234.693.461zm-30.898 71.078c-4.44-6.215-7.062-13.818-7.062-22.039s2.622-15.824 7.062-22.039c4.441 6.215 7.062 13.818 7.062 22.039s-2.621 15.824-7.062 22.039zm-61.795 0c-4.441-6.215-7.063-13.818-7.063-22.039s2.622-15.825 7.063-22.04c4.44 6.215 7.062 13.819 7.062 22.04S146.44 65.324 142 71.539zm-61.795 0c-4.441-6.215-7.063-13.818-7.063-22.039s2.622-15.825 7.063-22.04a37.777 37.777 0 0 1 7.063 22.04 37.774 37.774 0 0 1-7.063 22.039zM11.346 49.5c0-20.966 16.996-37.961 37.961-37.961a37.786 37.786 0 0 1 23.104 7.849C65.933 27.7 62.063 38.145 62.063 49.5c0 11.354 3.87 21.8 10.348 30.111a37.786 37.786 0 0 1-23.104 7.849c-20.965 0-37.961-16.995-37.961-37.96zm76.653 30.111c6.478-8.312 10.348-18.757 10.348-30.111 0-11.355-3.87-21.8-10.348-30.112a37.786 37.786 0 0 1 23.104-7.849 37.786 37.786 0 0 1 23.104 7.849c-6.479 8.312-10.348 18.757-10.348 30.112 0 11.354 3.87 21.799 10.348 30.111a37.786 37.786 0 0 1-23.104 7.849 37.784 37.784 0 0 1-23.104-7.849zm61.795 0c6.479-8.312 10.349-18.757 10.349-30.111 0-11.355-3.87-21.8-10.349-30.112 6.4-4.918 14.408-7.849 23.104-7.849s16.703 2.931 23.104 7.85c-6.479 8.312-10.348 18.756-10.348 30.111 0 11.354 3.869 21.799 10.348 30.111a37.786 37.786 0 0 1-23.104 7.849 37.786 37.786 0 0 1-23.104-7.849zm84.899 7.849a37.79 37.79 0 0 1-23.104-7.849c6.478-8.312 10.348-18.757 10.348-30.111 0-11.355-3.87-21.8-10.349-30.111a37.783 37.783 0 0 1 23.104-7.85c20.965 0 37.961 16.996 37.961 37.961s-16.995 37.96-37.96 37.96z"/></g></switch></svg>
    </div>
    <template v-if="loginStatus.loggedIn && !$route.path.includes('visit_cancellation')">
      <div class="menu-controls">
        <div
          @click="toggleNav"
          class="burger-menu"
          :class="{ 'open': showNav }"
        >
          <span />
          <span />
          <span />
        </div>
        <ul
          class="navigation-list"
          :class="{ 'open': showNav }"
        >
          <li
            class="navigation-element"
            v-for="(elem, index) in navigation"
            :class="{ 'active': checkActiveRoute(elem.to) }"
            :key="index"
          >
            <router-link
              class="navigation-element-link"
              :to="elem.to"
              @click.native="toggleNav"
            >
              {{ elem.name }}
            </router-link>
          </li>
          <li class="vgp-link">
            <a href="https://www.audi.pl/">
              Przejdź do <span>audi.pl</span>
            </a>
          </li>
          <div class="spacer" />
          <div class="user-controls">
            <div class="user-info">
              Zalogowany jako:
              <span class="bold">
                {{ `${userInfo.firstName} ${userInfo.lastName}` }}
              </span>
            </div>
            <div class="user-buttons">
              <button
                class="icon-button "
                @click="goToUserProfile"
                v-tooltip.bottom="{ content: 'Profil', classes: 'nav-buttons-tooltip' }"
              >
                <svg class="user-icon" svg-inline="" role="presentation" focusable="false" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 21.5v-7c0-.6.4-1 1-1h11c.6 0 1 .4 1 1v7h-13zm5-18h3c1.1 0 2 .9 2 2v3c0 1.1-.9 2-2 2h-3c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2z" stroke="currentColor" fill="none"/></svg>
              </button>
              <button
                class="icon-button"
                @click="onLogout()"
                v-tooltip.bottom="{ content: 'Wyloguj', classes: 'nav-buttons-tooltip' }"
              >
                <svg class="logout-icon" svg-inline="" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M3.4 21V4h12V3h-13v19h13v-1h-12zM18 8.9l-.7.7 2.3 2.3H8.4v1h11.3l-2.3 2.3.7.7 3.6-3.6L18 8.9z"/></svg>
              </button>
            </div>
          </div>
        </ul>
      </div>
      <div
        v-show="isMobile && showNav"
        @click.self="toggleNav"
        class="nav-mobile-overlay"
      />
    </template>
    <div
      class="vgp-link"
      v-else
    >
      <a
        href="https://www.audi.pl/"
        :style="{
          color: $route.path.includes('no_auth') ? 'black' : 'white',
        }"
      >
        Przejdź do <span>audi.pl</span>
      </a>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    hideNav: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      thirdColor: 'brand/getThirdColor',
      primaryColor: 'brand/getPrimaryColor',
      userInfo: 'user/getUserInfo',
      loginStatus: 'auth/getAuthStatus',
      fonts: 'brand/getFonts',
    }),
    isMobile() {
      return this.$mq === 'mobile' || this.$mq === 'xs';
    },
    isLoginPage() {
      return this.$route.name.includes('LoginPage');
    },
  },
  data() {
    return {
      showNav: false,
      navigation: [
        {
          name: 'Moje samochody',
          to: '/dashboard/mycars',
        },
        {
          name: 'Wizyty serwisowe',
          to: '/dashboard/visits/next/all',
        },
        {
          name: 'Znajdź Partnera Serwisowego',
          to: '/dashboard/map',
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      logout: 'auth/logout',
    }),
    checkActiveRoute(path) {
      return path === this.$route.path;
    },
    onLogout() {
      this.toggleNav();
      this.logout();
    },
    goToUserProfile() {
      this.$router.push({ path: '/dashboard/profile' });
      if (this.isMobile) {
        this.toggleNav();
      }
    },
    toggleNav() {
      this.showNav = !this.showNav;
    },
  },
  watch: {
    hideNav() {
      if (this.hideNav) {
        this.showNav = false;
      }
    },
  },
};
</script>
